var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import { memo } from 'react';
import * as React from "react";
var SvgPin16 = /*#__PURE__*/memo(function (props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 17 17"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeWidth: 1.3,
    clipPath: "url(#pin16_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    d: "M3.168 10.475a.929.929 0 0 0 .9 1.163h9.194a.929.929 0 0 0 .9-1.163 4.66 4.66 0 0 0-2.07-2.782l1.04-4.68a.93.93 0 0 0-.91-1.13H5.107a.93.93 0 0 0-.907 1.13l1.04 4.68a4.66 4.66 0 0 0-2.071 2.782Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.666 12.26v3.361"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "pin16_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M.666.5h16v16h-16z"
  })))));
});
SvgPin16.displayName = "SvgPin16";
export default SvgPin16;